import React from 'react';
import BoardForm from '../components/Board/BoardForm';

const BoardCreatePage: React.FC = () => <BoardForm />;

export default BoardCreatePage; 